module.exports = __webpack_public_path__ + "img/cross.461b91f3.svg";